module.exports = __webpack_public_path__ + "img/lingua_portuguesa.2f35312c.svg";